<template>
  <!-- 显示在手机端的列表，整页滚动,在web端表现有问题 -->
  <div class="mobile-list" :class="hasMore?'': 'no-more'">
    <div v-if="loadPageDom" ref="list" class="data-list" @scroll="scrollList" v-infinite-scroll="loadData" infinite-scroll-delay="500" :infinite-scroll-disabled="!hasMore">
      <div class="no-more" v-if="showRefreshTitle">下拉刷新数据</div>
      <slot/>
      <div class="no-more" v-if="!hasMore">{{loading? '加载中...': '没有更多了'}}</div>
    </div>
    <div class="loading-info" v-if="loading">加载中...</div>
  </div>
</template>

<script>

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    queryList: { // 查询列表
      type: Function,
      default: null
    },
    refresh: { // 刷新列表
      type: Function,
      default: null
    }
  },
  name: "ML",
  components: {
  },
  data() {
    return {
      loadPageDom: false,
      showRefreshTitle: false, // 显示文本提醒：下拉刷新数据
      // ★ 一次加载结束后，必须发生过一次新的用户滚动，才允许再次自动加载。
      //   否则请求失败（如 3010 无数据权限）时 hasMore 仍为 true、列表没有新增内容，
      //   无限滚动指令会在底部反复触发，形成无限请求。
      loadLocked: false,
    };
  },
  watch: {
    // 新的一轮查询（如重新搜索/刷新）把 hasMore 置回 true 时，解除锁定
    hasMore(value) {
      if (value) {
        this.loadLocked = false;
      }
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick().then(() => this.loadPageDom = true)
  },
  methods: {
    // 查询数据
    loadData() {
      console.log("loadData")
      if (this.hasMore && !this.loading && !this.loadLocked) {
        this.loadLocked = true;
        this.queryList();
      }
    },
    scrollList() {
      // 用户产生了新的滚动，允许下一次触底加载
      this.loadLocked = false;
      if (this.loading) {
        // 正在加载中，返回
        return;
      }
      if (!this.refresh) { // 没有刷新功能
        return;
      }
      let top = this.$refs.list.scrollTop;
      // 如果向下滚动的高度超过50，显示文本提醒
      if (top < -30) {
        this.showRefreshTitle = true;
      }
      // 如果向下滚动的高度超过100px，触发重新加载事件
      if (top < -100) {
        this.refreshList();
      }
      if (top >= 0) {
        this.showRefreshTitle = false;
      }
    },
    // 刷新列表数据
    refreshList() {
      if (this.loading) {
        return;
      }
      this.refresh();
    },
    // 隐藏刷新提示
    hideRefreshTitle() {
      this.showRefreshTitle = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-list{
  flex: 1;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  font-size: var(--yq-font-size-mini-mobile);
  &.no-more{
    padding-bottom: 30px;
  }
  .data-list{
    height: 100%;
    overflow-y: auto;
    padding: 0 10px;
    .no-more{
      text-align: center;
      color: var(--yq-font-color-desc);
    }
  }
  .loading-info{
    position: absolute;
    width: 100%;
    text-align: center;
    background: rgba(255,255,255,0.8);
    left: 0;
    bottom: 0;
    height: 30px;
    line-height: 30px;
  }
}
</style>